// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__V-41h","global":"layout_global__wtnXy"};